module.exports = __webpack_public_path__ + "JM.png?d7ba224599e6cc19cbf4ea7d0b54998b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/JM.png
// module id = 365
// module chunks = 0